exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.noti-list[data-v-f6959a4c] {\n  height: 100%;\n  overflow-y: scroll;\n}\n\n/* Hide scrollbar for Chrome, Safari and Opera */\n.noti-list[data-v-f6959a4c]::-webkit-scrollbar {\n  display: none;\n}\n\n/* Hide scrollbar for IE, Edge and Firefox */\n.noti-list[data-v-f6959a4c] {\n  -ms-overflow-style: none; /* IE and Edge */\n  scrollbar-width: none; /* Firefox */\n}\n.empty-list[data-v-f6959a4c] {\n  color: #8c623a;\n  font-weight: 600;\n  font-size: 0.9em;\n  height: 50%;\n  background-color: #e8dfc7;\n  margin: 3%;\n  border-radius: 0.8em;\n}\n", ""]);

// exports
